import { Box, Grid, Typography } from '@mui/material';
import { format } from 'date-fns';
import { memo } from 'react';

import NoteIcon from './assets/note-icon.svg?react';
import { noteIconBoxSx, noteTextSx, noteTimestampSx, noteTitleSx } from './styles';
import { ISingleNote } from './utils/types';

export const SingleNote = memo<ISingleNote>(({ title, text, timestamp, index, handleClickToEditNote }) => (
  <Grid
    container
    onClick={(): void => handleClickToEditNote({ title, text }, index)}
    flexWrap="nowrap"
    spacing={4}
    sx={{ cursor: 'pointer' }}
  >
    <Grid size="auto">
      <Box sx={noteIconBoxSx}>
        <NoteIcon />
      </Box>
    </Grid>
    <Grid size="grow" sx={{ minWidth: 0 }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
        <Typography noWrap sx={noteTitleSx}>
          {title || 'Note'}
        </Typography>
        <Typography sx={noteTimestampSx}>{format(timestamp * 1000 || 1674065538, 'dd MMM yyyy')}</Typography>
      </Box>
      <Typography sx={noteTextSx}>{text}</Typography>
    </Grid>
  </Grid>
));
